import { CalendarDays, Camera, Clock3, History, Home, LogOut, Settings, Sparkles } from 'lucide-react'
import { NavLink, Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { useMarlovaStore } from '../store'
import { Button } from './UI'

const navItems = [
  { to: '/today', label: 'Today', icon: Home },
  { to: '/history', label: 'History', icon: History },
  { to: '/settings/profile', label: 'Settings', icon: Settings },
]

export function AppShell() {
  const account = useMarlovaStore((state) => state.account)
  const authenticated = useMarlovaStore((state) => state.authenticated)
  const logout = useMarlovaStore((state) => state.logout)
  const location = useLocation()
  const navigate = useNavigate()
  const { needRefresh: [needRefresh], updateServiceWorker } = useRegisterSW()

  if (!authenticated || !account) return <Navigate to="/welcome" replace state={{ from: location.pathname }} />
  if (account.onboardingStep !== 'completed' && !location.pathname.startsWith('/onboarding')) {
    return <Navigate to={`/onboarding/${account.onboardingStep}`} replace />
  }

  if (location.pathname.startsWith('/onboarding')) {
    return (
      <div className="onboarding-shell">
        <header className="onboarding-shell__header">
          <img src="/brand/marlova-horizontal-compact.svg" alt="Marlova" />
          <span>Account setup</span>
        </header>
        <main id="main-content"><Outlet /></main>
      </div>
    )
  }

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <img src="/brand/marlova-horizontal-compact.svg" alt="Marlova" className="sidebar__logo" />
        <nav aria-label="Main navigation">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} className={({ isActive }) => isActive ? 'sidebar__link is-active' : 'sidebar__link'}>
              <Icon size={20} aria-hidden="true" /><span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar__tip">
          <Sparkles size={20} aria-hidden="true" />
          <strong>Small details help</strong>
          <span>Mention oils, sauces, and how much you ate.</span>
        </div>
        <button className="sidebar__account" onClick={() => { void logout().then(() => navigate('/welcome')) }}>
          <span>{account.email.slice(0, 1).toUpperCase()}</span>
          <div><strong>{account.email.split('@')[0]}</strong><small>Log out</small></div>
          <LogOut size={17} />
        </button>
      </aside>

      <div className="app-main">
        <header className="mobile-header">
          <img src="/brand/marlova-horizontal-compact.svg" alt="Marlova" />
          <div className="mobile-header__date"><CalendarDays size={16} />{new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' }).format(new Date())}</div>
        </header>
        <main id="main-content"><Outlet /></main>
      </div>

      <nav className="bottom-nav" aria-label="Main navigation">
        <NavLink to="/today"><Home /><span>Today</span></NavLink>
        <NavLink to="/history"><Clock3 /><span>History</span></NavLink>
        <NavLink to="/log/category" className="bottom-nav__log"><span><Camera /></span><b>Log meal</b></NavLink>
        <NavLink to="/settings/profile"><Settings /><span>Settings</span></NavLink>
      </nav>

      {location.pathname === '/today' || location.pathname === '/history' || location.pathname.startsWith('/meals/') ? <Button className="desktop-log-button" size="lg" onClick={() => navigate('/log/category')}><Camera size={20} /> Log a meal</Button> : null}
      {needRefresh ? (
        <div className="update-toast" role="status">
          <div><strong>A new Marlova version is available.</strong><span>Your draft will be kept safe.</span></div>
          <Button size="sm" onClick={() => updateServiceWorker(true)}>Update now</Button>
        </div>
      ) : null}
    </div>
  )
}
